export default function PromotionSkeletonDetails() {
    return (
        <div
            className="promotion-page-main all-page-main-container-min-height"
            role="status"
            aria-label="Loading promotion details"
            aria-busy="true"
        >
            <div className="promotion-page-container main-container-global-adjusted-padding">
                <div className="promotion-tnc-page">
                    {/* Breadcrumb */}
                    <div className="promotion-page-breadcrumb">
                        <div className="pds-breadcrumb pds-shimmer" />
                    </div>

                    {/* Main Banner */}
                    <div className="promotion-tnc-banner">
                        <div className="pds-banner pds-shimmer" />

                        <div className="promotion-tnc-content">
                            {/* Promotion Information */}
                            <div className="promotion-tnc-info">
                                <div className="pds-status pds-shimmer" />

                                <div className="pds-title pds-shimmer" />

                                <div className="pds-subtitle pds-shimmer" />

                                <div className="promotion-tnc-period">
                                    <div className="pds-period pds-shimmer" />
                                </div>
                            </div>

                            {/* Promo Mechanics Container */}
                            <div className="promotion-tnc-mechanic-content pds-mechanics">
                                <div className="pds-mechanics-header">
                                    <div className="pds-mechanics-title pds-shimmer" />

                                    <div className="pds-view-game pds-shimmer" />
                                </div>

                                {/* First paragraph */}
                                <div className="pds-paragraph">
                                    <div className="pds-line pds-shimmer" />
                                    <div className="pds-line pds-shimmer" />
                                    <div className="pds-line short pds-shimmer" />
                                </div>

                                {/* First Table */}
                                <div className="pds-table">
                                    <div className="pds-table-row">
                                        <div className="pds-cell pds-shimmer" />
                                        <div className="pds-cell pds-shimmer" />
                                        <div className="pds-cell pds-shimmer" />
                                        <div className="pds-cell pds-shimmer" />
                                    </div>

                                    {Array.from({ length: 5 }).map(
                                        (_, index) => (
                                            <div
                                                className="pds-table-row"
                                                key={index}
                                            >
                                                <div className="pds-cell pds-shimmer" />
                                                <div className="pds-cell pds-shimmer" />
                                                <div className="pds-cell pds-shimmer" />
                                                <div className="pds-cell pds-shimmer" />
                                            </div>
                                        )
                                    )}
                                </div>

                                {/* Additional Content */}
                                <div className="pds-paragraph">
                                    <div className="pds-line pds-shimmer" />
                                    <div className="pds-line pds-shimmer" />
                                    <div className="pds-line medium pds-shimmer" />
                                </div>

                                <div className="pds-section-title pds-shimmer" />

                                <div className="pds-paragraph">
                                    <div className="pds-line pds-shimmer" />
                                    <div className="pds-line pds-shimmer" />
                                    <div className="pds-line short pds-shimmer" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
